module.exports = __webpack_public_path__ + "static/media/buzzumo3.44889917.png";